import { classNames } from '../utilities';

export const AddIcon = ({ className, onClick }) => {
  return (
    <svg
      className={classNames(
        'add-icon cursor-pointer',
        className ? className : ''
      )}
      onClick={onClick ? onClick : () => null}
      width="26"
      height="28"
      viewBox="0 0 61 53"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="61" height="53" rx="8" fill="#00D090" />
      <path
        d="M42.1429 28.8571H32.8571V38.1429C32.8571 38.6354 32.6615 39.1078 32.3132 39.4561C31.9649 39.8043 31.4925 40 31 40C30.5075 40 30.0351 39.8043 29.6868 39.4561C29.3385 39.1078 29.1429 38.6354 29.1429 38.1429V28.8571H19.8571C19.3646 28.8571 18.8922 28.6615 18.5439 28.3132C18.1957 27.9649 18 27.4925 18 27C18 26.5075 18.1957 26.0351 18.5439 25.6868C18.8922 25.3385 19.3646 25.1429 19.8571 25.1429H29.1429V15.8571C29.1429 15.3646 29.3385 14.8922 29.6868 14.5439C30.0351 14.1957 30.5075 14 31 14C31.4925 14 31.9649 14.1957 32.3132 14.5439C32.6615 14.8922 32.8571 15.3646 32.8571 15.8571V25.1429H42.1429C42.6354 25.1429 43.1078 25.3385 43.4561 25.6868C43.8043 26.0351 44 26.5075 44 27C44 27.4925 43.8043 27.9649 43.4561 28.3132C43.1078 28.6615 42.6354 28.8571 42.1429 28.8571Z"
        fill="white"
      />
    </svg>
  );
};
